module.exports = require('../impls/$take-last/async-take-last.js').asyncTakeLast;